'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function values(object) {
    if (object == null) {
        return [];
    }
    return Object.values(object);
}

exports.values = values;
